var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blog-posts"},[_c('div',{staticClass:"all-posts row mt-4"},_vm._l((_vm.posts),function(post){return _c('div',{key:post._id,staticClass:"col-lg-6 mb-4"},[_c('BlogPostCardTemplate',{attrs:{"post":post}})],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }